export enum DSRoutes {
  HOME = ':organizationId',
  WORKSPACES = 'workspaces',
  WORKSPACES_ARCHIVED = 'workspaces/archived',
  WORKSPACE = 'workspace/:workspaceId',
  DEMO_PAGE = 'demo/:demoId/:tabId/:innerTabId?/*',
  TOUR_PAGE = 'tour/:tourId/:tabId',
  CLONE_PAGE = 'clone/:recordingId/:tabId',
  PLAYBOOK_PAGE = 'playbook/:playbookId/:tabId/:innerTabId?',
  TEAM_ACTIVITIES = 'activities',
  NOTIFICATIONS_SETTINGS = 'notifications/settings',
}

export enum TabRoutes {
  PLAYBOOK_PRESENTATION_DEMO_PRESENT = 'organization/:organizationId/workspace/:workspaceId/playbook-presentation/demo/:demoId/present',
}
